import { FilterList } from "@mui/icons-material";
import { Badge, Button, Menu, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useState } from "react";
import { IssuesFilterToggleButton, IssuesSortToggleButton } from "../../../../components";
import {
  IssuesFilterByOption,
  IssuesSortByOption,
  IssueStatus,
  SortByDirection,
  TeamIssuesGroupByOption,
} from "../../../../constants";
import { useTeamImplementationSettings } from "../hooks";

interface Props {
  teamSlug: string;
  disabled: boolean;
}

const TeamIssuesFilterButton = (props: Props) => {
  const { settings, updateSettings } = useTeamImplementationSettings(props.teamSlug);
  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);

  function handleGroupByChanged(value: TeamIssuesGroupByOption) {
    if (value != null) {
      updateSettings({
        issuesGroupByOption: value,
      });
    }
  }

  function handleFilterByChanged(filterByOption: IssuesFilterByOption, filterByStatusOption: IssueStatus | undefined) {
    updateSettings({
      issuesFilterByOption: filterByOption,
      issuesFilterByStatusOption: filterByStatusOption,
    });
  }

  function handleSortByChanged(value: IssuesSortByOption) {
    if (value != null) {
      updateSettings({
        issuesSortByOption: value,
      });
    }
  }

  function handleSortDirectionChanged() {
    if (settings.issuesSortByDirection === SortByDirection.Ascending) {
      updateSettings({
        issuesSortByDirection: SortByDirection.Descending,
      });
    } else {
      updateSettings({
        issuesSortByDirection: SortByDirection.Ascending,
      });
    }
  }

  return (
    <>
      <Badge color="primary" variant="dot" invisible={settings.issuesFilterByOption === IssuesFilterByOption.All}>
        <Button
          variant="tertiary"
          disabled={props.disabled}
          sx={{ minWidth: 0, p: 0.25 }}
          onClick={(e) => setMenuAnchor(e.currentTarget)}
        >
          <FilterList />
        </Button>
      </Badge>

      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={() => setMenuAnchor(null)}
        slotProps={{ paper: { sx: { minWidth: 200 } } }}
        anchorOrigin={{
          horizontal: "right",
          vertical: "bottom",
        }}
        transformOrigin={{
          horizontal: "right",
          vertical: "top",
        }}
      >
        <Typography variant="overline" sx={{ mx: 0.5 }}>
          Group By
        </Typography>
        <ToggleButtonGroup
          value={settings.issuesGroupByOption}
          exclusive
          orientation="vertical"
          variant="menu"
          onChange={(_, value) => handleGroupByChanged(value)}
          sx={{ minWidth: "100%" }}
        >
          <ToggleButton value={TeamIssuesGroupByOption.None}>
            <Typography>None</Typography>
          </ToggleButton>
          <ToggleButton value={TeamIssuesGroupByOption.CreatedBy}>
            <Typography>Creator</Typography>
          </ToggleButton>
          <ToggleButton value={TeamIssuesGroupByOption.Status}>
            <Typography>Status</Typography>
          </ToggleButton>
        </ToggleButtonGroup>

        <Typography variant="overline" sx={{ mx: 0.5, mt: 1 }}>
          Filter By
        </Typography>
        <IssuesFilterToggleButton
          filterByOption={settings.issuesFilterByOption}
          filterByStatusOption={settings.issuesFilterByStatusOption}
          onChange={handleFilterByChanged}
        />

        <Typography variant="overline" sx={{ mx: 0.5, mt: 1 }}>
          Sort By
        </Typography>
        <IssuesSortToggleButton
          sortByOption={settings.issuesSortByOption}
          sortByDirection={settings.issuesSortByDirection}
          onSortByChanged={handleSortByChanged}
          onSortDirectionChanged={handleSortDirectionChanged}
        />
      </Menu>
    </>
  );
};

export { TeamIssuesFilterButton };
